﻿import { axiosInstance } from "../../utils";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useToast } from "@chakra-ui/react";
import { EntityCandidate } from "../models/EntityCandidate";

export type CandidateCommentParameter = {
    id: string;
    candidateId: string;
    candidate: EntityCandidate;
    body: string;
    createdOn: string;
    createdByName: string;
    createdById: string;
    updatedOn: string;
    updatedById: string;
    deletedOn: string;
    deletedById: string;
    tenantId: string;
    entityId: string;
    refetch: () => void;
};

export function useCandidateCommentDelete() {
    const axios = axiosInstance();
    const toast = useToast();

    return useMutation({
        mutationFn: (comment: CandidateCommentParameter) => {
            return axios
                .delete<CandidateCommentParameter>(
                    `api/Clients/${comment.tenantId}/entities/${comment.entityId}/candidates/${comment.candidateId}/comments/${comment.id}`
                )
                .then(response => response.data);
        },
        onSuccess: async (data, variables) => {
            toast({
                title: "Deleted",
                description: "Comment deleted successfully.",
                status: "success",
                duration: 3000,
                isClosable: true,
            });
        },
        onError: error => {
            const axiosError = error as AxiosError;
            toast({
                title: "Unable to delete comment",
                description: `[${axiosError.request.status ?? "ERR"}]: ${axiosError.message}`,
                status: "error",
                isClosable: true,
                duration: null,
            });
        },
    });
}
